import { render, staticRenderFns } from "./alert-recent.vue?vue&type=template&id=09c3ae32&scoped=true&"
import script from "./alert-recent.vue?vue&type=script&lang=js&"
export * from "./alert-recent.vue?vue&type=script&lang=js&"
import style0 from "./alert-recent.vue?vue&type=style&index=0&id=09c3ae32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c3ae32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
installComponents(component, {VAppBar})
